import VehicleQuiz from "../entities/valueObjects/vehicleQuiz";

export default class VehicleQuizDTO {
  static fromJson(json: any): VehicleQuiz {
    return new VehicleQuiz(
      json.value,
      json.isOwned,
      json.isThirdParty,
      json.isFinanced,
      json.wantsRefinance,
      json.refinanceValue,
      json.useAsPayment,
      json.vehicleType,
      json.year,
      json.model,
      json.manufacturer,
      json.km,
      json.thirdPartyDocument,
      json.fipeValue
    );
  }

  static toJson(vehicleQuiz: VehicleQuiz): any {
    return {
      value: vehicleQuiz.value,
      isOwned: vehicleQuiz.isOwned,
      isThirdParty: vehicleQuiz.isThirdParty,
      isFinanced: vehicleQuiz.isFinanced,
      wantsRefinance: vehicleQuiz.wantsRefinance,
      refinanceValue: vehicleQuiz.refinanceValue,
      useAsPayment: vehicleQuiz.useAsPayment,
      vehicleType: vehicleQuiz.vehicleType,
      year: vehicleQuiz.year,
      model: vehicleQuiz.model,
      manufacturer: vehicleQuiz.manufacturer,
      km: vehicleQuiz.km,
      thirdPartyDocument: vehicleQuiz.thirdPartyDocument,
      fipeValue: vehicleQuiz.fipeValue,
    };
  }
}
